import getRequestUrl from "./getRequestUrl";
import getRequestAndHeaders from "./getRequestAndHeaders";

export default async ({ variantId }) => {
  const { request, headers } = await getRequestAndHeaders();
  const requestUrl = getRequestUrl();

  request.put({
    url: requestUrl,
    headers,
    body: { variantId }
  });
};
